import { produce, Draft } from 'immer'
import { IAction, TActionTypes } from '@Root/types'

import {
  ExternalTokenActionTypes,
  IExternalTokenState,
  TExternalTokenActionTypes,
  ICreateOrUpdateExternalTokenSuccessResponseBody,
  IFetchExternalTokensSuccessResponseBody,
  IDeleteExternalTokenPayload,
} from './types'

export const initialState: IExternalTokenState = {
  externalTokens: [],
  loading: false
}

type TAction = TActionTypes | TExternalTokenActionTypes

export const externalTokenReducer = (
  state: IExternalTokenState = initialState,
  action: TAction
): IExternalTokenState => {
  return produce(state, draft => {
    switch (action.type) {
      case ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS:
      case ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN:
      case ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN:
        createOrUpdateExternalToken(draft)
        break

      case ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS_SUCCESS:
        fetchExternalTokensSuccess(draft, action)
        break

      case ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN_SUCCESS:
        createOrUpdateExternalTokenSuccess(draft, action)
        break

      case ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS_FAILURE:
      case ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN_FAILURE:
      case ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN_FAILURE:
        createOrUpdateExternalTokenFailure(draft)
        break

      case ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN_SUCCESS:
        deleteExternalTokenSuccess(draft, action)
        break

      default:
        break
    }
  })
}

const createOrUpdateExternalToken = (draft: Draft<IExternalTokenState>) => {
  draft.loading = true
}

function isIFetchExternalTokensSuccessAction(arg: any): arg is IAction<IFetchExternalTokensSuccessResponseBody> {
  return arg.type === ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS_SUCCESS
}

const fetchExternalTokensSuccess = (draft: Draft<IExternalTokenState>, action: TAction) => {
  if (!isIFetchExternalTokensSuccessAction(action)) { return }

  draft.externalTokens = action.payload.data
  draft.loading = false
}

function isICreateOrUpdateExternalTokenSuccessAction(arg: any): arg is IAction<ICreateOrUpdateExternalTokenSuccessResponseBody> {
  return arg.type === ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN_SUCCESS
}

const createOrUpdateExternalTokenSuccess = (draft: Draft<IExternalTokenState>, action: TAction) => {
  if (!isICreateOrUpdateExternalTokenSuccessAction(action)) { return }

  draft.externalTokens = [action.payload.data, ...draft.externalTokens]
  draft.loading = false
}

const createOrUpdateExternalTokenFailure = (draft: Draft<IExternalTokenState>) => {
  draft.loading = false
}

function isIDeleteExternalTokenSuccessAction(arg: any): arg is IAction<IDeleteExternalTokenPayload> {
  return arg.type === ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN_SUCCESS
}

const deleteExternalTokenSuccess = (draft: Draft<IExternalTokenState>, action: TAction) => {
  if (!isIDeleteExternalTokenSuccessAction(action)) { return }

  draft.externalTokens = draft.externalTokens.filter(externalToken => externalToken.id !== action.payload.externalTokenId)
  draft.loading = false
}
